import request from './http'
// 获取小程序二维码
export function getWcWeb (data) {
  return request({
    method: 'post',
    url: '/wc-web/api',
    headers: { api_new: 'true' },
    data: data
  })
}
export function authAddString (data) {
  // return postV2('webapi.auth.addstring', data, postV2Api.webApi)
  return request({
    method: 'post',
    url: '/webapi/api',
    headers: { api_new: 'true' },
    data: data
  })
}
